import { useParams } from 'react-router-dom';
import InterventionArbre from '@repo/ui/features/inventaires/arbre/intervention/index';

export default function ArbreInterventionPage() {
  const { id = '' } = useParams<{ id?: string }>();

  return (
    <div className="w-full py-6">
      <InterventionArbre inventaireId={Number(id)} />
    </div>
  );
}
